import "./index.css"; // Assuming you have a CSS file for styling

import React, { useState } from "react";

const VerfiedTooltipBtn = ({ value }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <div className="settlement-tooltip-btn" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <svg
        fill={value ? "#39A78E" : "#D33030"}
        width="24px"
        height="20px"
        viewBox="0 0 512 512"
        id="_x30_1"
        version="1.1"
      >
        <g>
          <path d="M312.016,222.911c-7.139-7.139-18.714-7.139-25.854,0l-47.398,47.398l-12.927-12.927c-7.139-7.139-18.714-7.139-25.854,0   l0,0c-7.139,7.139-7.139,18.714,0,25.854l25.854,25.854c7.139,7.139,18.714,7.139,25.854,0l60.325-60.325   C319.155,241.625,319.155,230.05,312.016,222.911L312.016,222.911z" />

          <path d="M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.615,256-256S397.385,0,256,0z M390.062,299.737   c0,23.235-11.042,45.087-29.747,58.87l-71.317,52.549C279.438,418.2,267.875,422,256,422s-23.438-3.8-32.999-10.844l-71.317-52.549   c-18.705-13.783-29.747-35.635-29.747-58.87V173.359c0-15.951,10.341-30.062,25.552-34.865l72.796-22.988   C231.84,111.857,243.884,110,256,110s24.16,1.857,35.714,5.505l72.796,22.988c15.211,4.803,25.552,18.914,25.552,34.865V299.737z" />
        </g>
      </svg>
      {showTooltip && (
        <div className="tooltip">{value ? "  مورد تأیید پذیرنده" : "  عدم تأیید توسط پذیرنده"}</div>
      )}
    </div>
  );
};

export default VerfiedTooltipBtn;
